import { useEffect } from 'react';
export const useOutsideClick = (popoverContainer, buttonContainer, isPopoverOpen, callback) => {
    useEffect(() => {
        const handleDocumentMouseDown = (event) => {
            const target = event.target;
            if (!target || !isPopoverOpen) {
                return;
            }
            const node = target;
            if (!popoverContainer.contains(node) && !buttonContainer.contains(node)) {
                callback();
            }
        };
        document.addEventListener('mousedown', handleDocumentMouseDown);
        return () => {
            document.removeEventListener('mousedown', handleDocumentMouseDown);
        };
    }, [popoverContainer, buttonContainer, isPopoverOpen, callback]);
};
//# sourceMappingURL=useOutsideClick.js.map